// libs
import { styled } from '@nykaa/ui-components';

//constants
import { MWEB_HEADER_ZINDEX } from 'shared/styles/base';

export const Container = styled.div`
  width: fit-content;
  box-shadow: ${({ theme }) => theme.elevations.shadow100};
  border-radius: ${({ theme }) => theme.borders.radius10};
  z-index: ${MWEB_HEADER_ZINDEX - 1};
`;

export const PopUpWrapper = styled.div`
  display: flex;
  // @ts-expect-error - filterSurface is a custom property not in UI components ColorTokens type
  background-color: ${({ theme }) => theme.colors.filterSurface};
  // @ts-expect-error - filterBackdropFilter is a custom property not in UI components ColorTokens type
  backdrop-filter: blur(${({ theme }) => theme.colors.filterBackdropFilter}px);
`;

export const Subheading = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const Wrapper = styled.div`
  position: relative;
`;
